import React from 'react';
import './css/App.css';
import { HashRouter as Router, Routes, Route, Navigate }
	from 'react-router-dom';
import Home from './pages/Home';
import Contact from './pages/contact';
import Faq from './pages/faq';

function App() {
	return (
		<Router>
			<Routes>
				<Route exact path='/' element={<Home />} />
				<Route path='/contact' element={<Contact />} />
				<Route path='/faq' element={<Faq />} />
                <Route
                    path='/fcn'
                    element={<Navigate to="/" replace />}
                />
		
            </Routes>
		</Router>
	);
}

export default App;

